// extracted by mini-css-extract-plugin
export default {"desktop":"h9uVX","root":"LJsef","mosList":"B8oKo","mosBlock":"SE9c_","navCircle":"yUXNv","image":"SdmQE","price":"GlPhF"};